document.addEventListener('DOMContentLoaded', () => {
    // Constants for selectors
    const CATEGORY_DIGITAL_CURRENCY_NEWS_SELECTOR = '.category-digital-currency-news';
    const SWIPE_BUTTON_SELECTOR = '.swipe-table-btn';
    const COMPARE_TABLE_WRAPPER_SHADOW_SELECTOR = '.compare-table-wrapper-shadow, .table-wrapper-shadow';
    const COMPARE_TOOL_TABLE_WRAPPER_SELECTOR = '.compare-tool-table-wrapper, .compare-table-wrapper';
    const TABLE_WRAPPER_SELECTOR = '.table-wrapper';
    const TABLE_COMPARISONS_SELECTOR = '.table-comparisons';
    const ARROW_ICON_HTML = '<i class="arrow-icon fa-solid fa-arrow-right"></i>';

    // Constants for class names
    const COMPARE_TABLE_WRAPPER_SHADOW_CLASS = 'compare-table-wrapper-shadow';
    const TABLE_WRAPPER_SHADOW_CLASS = 'table-wrapper-shadow';
    const SWIPE_TABLE_BTN_CLASS = 'swipe-table-btn';
    const TABLE_WRAPPER_CLASS = 'table-wrapper';

    // Utility functions
    const isScrollableHorizontally = (element) => element.scrollWidth > element.clientWidth;

    const scrollToEnd = (scrollTarget) => {
        const remainingScroll = scrollTarget.scrollWidth - (scrollTarget.scrollLeft + scrollTarget.clientWidth);
        if (remainingScroll > 0) {
            scrollTarget.scrollBy({ left: remainingScroll, behavior: 'smooth' });
        }
    };

    // Early return if there are no tables
    const tables = document.querySelectorAll('table');
    if (tables.length === 0) return;

    const updateShadows = () => {
        document.querySelectorAll(COMPARE_TABLE_WRAPPER_SHADOW_SELECTOR).forEach((wrapperShadow: HTMLElement) => {
            const isComparisonTable = wrapperShadow.classList.contains(COMPARE_TABLE_WRAPPER_SHADOW_CLASS);
            const tableWrapper = wrapperShadow.querySelector(
                isComparisonTable
                    ? COMPARE_TOOL_TABLE_WRAPPER_SELECTOR
                    : TABLE_WRAPPER_SELECTOR,
            );
            const table = isComparisonTable ? tableWrapper : tableWrapper?.querySelector('table') as HTMLElement;
            const swipeButton = wrapperShadow.querySelector(SWIPE_BUTTON_SELECTOR) as HTMLElement;
            const comparisonTable = wrapperShadow.querySelector(TABLE_COMPARISONS_SELECTOR) as HTMLElement;

            if (!tableWrapper || !table || !swipeButton) return;

            const isScrollableLeft = table.scrollLeft > 0;
            const isScrollableRight = table.scrollLeft + table.clientWidth < table.scrollWidth;
            const notFitsScreen = table.scrollWidth > table.clientWidth;

            wrapperShadow.classList.toggle(
                isComparisonTable ? 'scrollable-left' : 'content-table-scrollable-left',
                isScrollableLeft,
            );
            wrapperShadow.classList.toggle(
                isComparisonTable ? 'scrollable-right' : 'content-table-scrollable-right',
                isScrollableRight,
            );

            if (notFitsScreen) {
                swipeButton.style.display = 'flex';
                swipeButton.style.visibility = isScrollableRight ? 'visible' : 'hidden';
            } else {
                swipeButton.style.display = 'none';
            }

            if (comparisonTable && !notFitsScreen) {
                tableWrapper.classList.add('mt-4');
            }
        });
    };

    document.querySelectorAll(SWIPE_BUTTON_SELECTOR).forEach((swipeButton: HTMLElement) => {
        // eslint-disable-next-line func-names
        swipeButton.addEventListener('click', function () {
            const wrapperShadow = this.closest(COMPARE_TABLE_WRAPPER_SHADOW_SELECTOR);
            if (!wrapperShadow) return;

            const isComparisonTable = wrapperShadow.classList.contains(COMPARE_TABLE_WRAPPER_SHADOW_CLASS);
            const tableWrapper = wrapperShadow.querySelector(
                isComparisonTable
                    ? COMPARE_TOOL_TABLE_WRAPPER_SELECTOR
                    : TABLE_WRAPPER_SELECTOR,
            );
            const table = isComparisonTable ? tableWrapper : tableWrapper?.querySelector('table');

            if (table && isScrollableHorizontally(table)) {
                scrollToEnd(table);
            }
        });
    });

    document.querySelectorAll('table:not(.table-comparisons):not(.small-table):not(.big-table)').forEach((table: HTMLElement) => {
        // Early return if the table is inside .category-digital-currency-news
        if (table.closest(CATEGORY_DIGITAL_CURRENCY_NEWS_SELECTOR)) return;

        const wrapperShadow = document.createElement('div');
        wrapperShadow.classList.add(TABLE_WRAPPER_SHADOW_CLASS);

        const swipeButton = document.createElement('div');
        swipeButton.classList.add(SWIPE_TABLE_BTN_CLASS);
        swipeButton.innerHTML = ARROW_ICON_HTML;

        const tableWrapper = document.createElement('div');
        tableWrapper.classList.add(TABLE_WRAPPER_CLASS);

        table.parentNode.insertBefore(wrapperShadow, table);
        tableWrapper.appendChild(table);
        wrapperShadow.appendChild(swipeButton);
        wrapperShadow.appendChild(tableWrapper);

        swipeButton.addEventListener('click', () => scrollToEnd(table));
    });

    updateShadows();

    window.addEventListener('resize', updateShadows);
    window.addEventListener('scroll', updateShadows);
    document.querySelectorAll(`${COMPARE_TOOL_TABLE_WRAPPER_SELECTOR}, ${TABLE_WRAPPER_SELECTOR}, .table-wrapper table`).forEach((table: HTMLElement) => {
        table.addEventListener('scroll', updateShadows);
    });
});
